// Enum for Personality Types
export const PERSONALITY_TYPES = {
  NOT_AVAILABLE: 'N/A',
  DESIGNER: 'Designer',
  LEADER: 'Leader',
  DRIVER: 'Driver',
  CREATOR: 'Creator',
  PERSUADER: 'Persuader',
  MOTIVATOR: 'Motivator',
  PROMOTER: 'Promoter',
  COLLABORATOR: 'Collaborator',
  ADVOCATE: 'Advocate',
  PROPONENT: 'Proponent',
  COORDINATOR: 'Coordinator',
  EQUALIZER: 'Equalizer',
  MANAGER: 'Manager',
  STRATEGIST: 'Strategist',
  CHALLENGER: 'Challenger',
  INVESTIGATOR: 'Investigator',
};

// Enum for Sort Audience -> Lists
export enum SortTypes {
  LAST_MODIFIED = 0,
  MOST_ENGAGED = 1,
  ALPHABETS = 2,
}

export enum ActionTypes {
  DELETE = 'delete',
  REMOVE = 'remove',
  CREATE = 'create',
  ADD_TO_LIST = 'add_to_list',
  IMPORT_LIST = 'import_list',
}

export enum TableHeadersSortBy {
  NAME = 'full_name',
  CONTACT = 'contact_name',
  COMPANY = 'company_name',
  PERSONALITY = 'personality_name',
  STATUS = 'status',
  CREATED_ON = 'created_on',
}

export enum TableHeading {
  NAME = 'Name',
  COMPANY = 'Company',
  PERSONALITY = 'Personality',
  STATUS = 'Status',
}

export const PERSONALITY_TYPES_DATA = [
  { name: 'N/A', value: 'N/A', color: '#000000' },
  { name: 'Designer', value: 'Designer', color: '#a94255' },
  { name: 'Leader', value: 'Leader', color: '#ed1012' },
  { name: 'Driver', value: 'Driver', color: '#ff0000' },
  { name: 'Creator', value: 'Creator', color: '#ff6700' },
  { name: 'Persuader', value: 'Persuader', color: '#ff8a00' },
  { name: 'Motivator', value: 'Motivator', color: '#ffb136' },
  { name: 'Promoter', value: 'Promoter', color: '#ceaf15' },
  { name: 'Collaborator', value: 'Collaborator', color: '#85af35' },
  { name: 'Advocate', value: 'Advocate', color: '#58b048' },
  { name: 'Proponent', value: 'Proponent', color: '#01b16d' },
  { name: 'Coordinator', value: 'Coordinator', color: '#00b79b' },
  { name: 'Equalizer', value: 'Equalizer', color: '#00b8b7' },
  { name: 'Manager', value: 'Manager', color: '#06bad2' },
  { name: 'Strategist', value: 'Strategist', color: '#00c1fd' },
  { name: 'Challenger', value: 'Challenger', color: '#3e91c1' },
  { name: 'Investigator', value: 'Investigator', color: '#6f6b8f' },
];

export const STATUS_TYPES_DATA = [
  { name: 'Subscribed', value: 'Subscribed' },
  { name: 'Hard Bounce', value: 'Hard Bounce' },
  { name: 'Unsubscribed', value: 'Unsubscribed' },
];

export const ContactStatusClass: { [key: string]: string } = {
  'Hard Bounce': 'hard-bounce',
  Unsubscribed: 'unsubscribed',
  Subscribed: 'subscribed',
};
